import { WidgetDefinition } from '../';

export const ManualInputsWidgetDefinition: WidgetDefinition = {
    baseType: 'ManualInputs',
    group: 'Charts',
    highlights: ['Manual input identifiers of selected group'],
    icon: '',
    sortingOrder: 0,
    title: 'Manual inputs',
    type: 'ManualInputs'
};